/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 ChillComputer.glb 
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export function ChillComputer(props) {
  const { nodes, materials } = useGLTF("/ChillComputer.glb");
  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.Plane011.geometry}
        material={materials["metal.001"]}
        position={[-1.85, 1.836, 1.421]}
        rotation={[0, -0.009, 0]}
        scale={[0.241, 0.265, 0.289]}
      >
        <group position={[0.927, 3.036, 0]}>
          <mesh
            geometry={nodes.Mesh.geometry}
            material={materials["metal.001"]}
            castShadow
            receiveShadow
          />
          <mesh geometry={nodes.Mesh_1.geometry} material={materials.screen} />
        </group>
      </mesh>
    </group>
  );
}

useGLTF.preload("/ChillComputer.glb");
